import { Fragment, useEffect, useState, useRef, useMemo } from "react";
import { FlightUtils } from "../../../common/FlightUtils";
import { TimeDateAndStops } from "../../../components/common/TimeDateAndStops";
import { useStaticImages } from "../../../hooks/useStaticImages";
import { useStoreFly } from "../../../store";
import CloseIcon from "@mui/icons-material/Close";
import sslIcon from "../../../assets/img/SSLIcon.png";
import BagGreen from "../../../assets/svg2/SVG Bags from Egzonarifi.svg";
import {
  AIRLINES_IMAGE_ENDPOINT,
  BOOKING_CHECK_FLIGHT,
  FLUTURO_LIRE_REDIRECT,
  GET_LIST_COUNTRY_ALL,
  ITRAVEL_KEY_API,
  MAIN_LAMBDA,
  MAIN_PASSENGER_INITIAL_FORM,
} from "../../../utils/constants";
import countriesData from "../../../utils/countries-min.json";
import { CODE_TO_SEVERITY, CURRENCY_SIGN, PARTNERID, SIGNATURE } from "../../../utils/enums";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { GET, POST } from "../../../utils/api";
import {
  addPercentageToPrice,
  calculateTotalTime,
  formatPrice,
  getItemFromLocalStorage,
  goToTebPaymentPage,
  isPhoneNumber,
  passengerBaggageForBooking,
  passengerDetailsForBooking,
} from "../../../common/methods";
import { useFlightDetails } from "../../../hooks/useFlightDetails";
import { useCheckFlight } from "../../../hooks/useCheckFlight";
import { BaggageSection } from "./BaggageSection";
import { ManagePassengers } from "./ManagePassenger";
import { AddedBaggageSection } from "./AddedBaggageSection";
import {
  FormWithConstraints,
  FieldFeedbacks,
  FieldFeedback,
} from "react-form-with-constraints";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { Form } from "react-bootstrap";
import { set } from "date-fns";
import { Add } from "@mui/icons-material";
import { IsMobileOrBrowser } from "../../../hooks/isBrowserOrMobile";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useFlightRouteDetails } from "../../../hooks/useFlightRouteDetails";
import { useTimeDifference } from "../../../hooks/useTimeDifference";
import TripSummaryItem from "./TripSummaryItem";
import { useStore } from "zustand";
import moment from "moment/moment";
import { countryTelData } from "../../../utils/countryTelData";

const FlightUtil = new FlightUtils();

// Modern styling constants (matching hotel booking)
const primaryColor = "#003663";

const inputStyle = {
  padding: "10px 15px",
  borderRadius: "12px",
  border: "1px solid #E5E9F2",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
  width: "100%",
  height: '54px',
  backgroundColor: '#F8FAFC',
  transition: 'all 0.2s ease-in-out',
  fontSize: '16px',
  fontWeight: '500',
  color: '#003663'
};

const formLabelStyle = (hasError) => ({
  color: hasError ? '#dc3545' : '#003663',
  fontWeight: '500',
  marginBottom: '4px', // tighter spacing
  fontSize: '1rem',
  transition: 'color 0.2s ease-in-out',
  borderBottom: hasError ? '2px solid #dc3545' : 'none',
  display: 'inline-block',
  paddingBottom: '2px'
});

const errorMessageStyle = {
  color: '#dc3545',
  fontSize: '0.875rem',
  marginTop: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
};

const cardStyle = {
  backgroundColor: "#fff",
  borderRadius: "0 0 16px 16px",
  padding: "24px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  margin: "24px auto",
  borderTop: "none",
  position: "relative",
  overflow: "hidden"
};

const blendOverlayStyle = {
  position: "absolute",
  top: "-20px",
  left: 0,
  right: 0,
  height: "20px",
  background: "linear-gradient(to bottom, #f8f9fa, #fff)",
  zIndex: 1
};

export const FlightDetails = ({ flight }) => {

  // All hooks must be called first before any conditional logic
  const navigate = useNavigate();
  const getpreciseSearchData = useStoreFly((state) => state.getpreciseSearchData);
  const translation = useTranslation();
  const isMobile = IsMobileOrBrowser();
  const returnOrOneWay = useStoreFly((state) => state.returnOrOneWay);
  const baggage = useStoreFly((state) => state.baggage);
  // updater to clear / set ancillary selections globally
  const updateAncillary = useStoreFly((state) => state.updateAncillary);
  const { passengers } = useFlightDetails(flight);
  const [consent, setConsent] = useState(false);
  const [disableBookingButton, setDisableBookingButton] = useState(false);
  const [bookingLoading, setBookingLoading] = useState(false);

  const [countries, setCountries] = useState([]);
  const [disableAddBaggage, setDisableAddBaggage] = useState(false);
  const { ssl, passport } = useStaticImages();
  const currency = useStoreFly((state) => state.currency);
  const carriers = useStoreFly((state) => state.airlines);
  const { adult = 0, children = 0, babies = 0 } = passengers;
  const totalPassengers = FlightUtil.getTotalPassenger(adult, children, babies);
  const [currentTotalPassengers, setCurrentTotalPassengers] =
    useState(totalPassengers);
  const [bookingDetails, setBookingDetails] = useState();
  const [freshPriceDialog, setFreshPriceDialog] = useState(false);
  const [addPassengerDetails, setAddPassengerDetails] = useState([]);
  const [passagersForFinalBooking, setFinalPassagersForBooking] = useState();
  const [mainPassengerForm, setMainPassengerForm] = useState(
    MAIN_PASSENGER_INITIAL_FORM
  );
  const [addedBaggage, setAddedBaggage] = useState([]);
  const [noCheckedBaggage, setNoCheckedBaggage] = useState(false);
  const [promoCode, setPromoCode] = useState(false);
  const [promoCodeValue, setPromoCodeValue] = useState("");
  const [newBaggageItem, setNewBaggageItem] = useState([]);
  const [preciseBookingData, setPreciseBookingData] = useState();

  const [totalBaggagePrice, setTotalBaggagePrice] = useState(0);
  const [passengersList, setPassengersList] = useState([]);
  const [formRef, setFormRef] = useState(null);
  const [redirectMessage, setRedirectMessage] = useState("");
  const [messageSeverity, setMessageSeverity] = useState("success");
  const [showRedirectMessage, setShowRedirectMessage] = useState(false);
  const [voucherInfo, setVoucherInfo] = useState({
    message: "",
    code: 0,
    loading: false,
  });

  // Modern dropdown states
  const [isNationalityOpen, setIsNationalityOpen] = useState(false);
  const [isBirthMonthOpen, setIsBirthMonthOpen] = useState(false);
  const [isExpiryMonthOpen, setIsExpiryMonthOpen] = useState(false);
  const [isPhoneCountryOpen, setIsPhoneCountryOpen] = useState(false);
  const [nationalitySearchQuery, setNationalitySearchQuery] = useState('');
  const [phoneCountrySearchQuery, setPhoneCountrySearchQuery] = useState('');
  const [selectedNationality, setSelectedNationality] = useState('');
  const [selectedBirthMonth, setSelectedBirthMonth] = useState('');
  const [selectedExpiryMonth, setSelectedExpiryMonth] = useState('');
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState('XK'); // Default to Kosovo

  // Dropdown refs
  const nationalityDropdownRef = useRef(null);
  const birthMonthDropdownRef = useRef(null);
  const expiryMonthDropdownRef = useRef(null);
  const phoneCountryDropdownRef = useRef(null);

  // Extended country data for phone codes – reuse authoritative mapping
  const extendedCountryTelData = {
    ...countryTelData,
    XK: { name: "Kosovo", dial_code: "+383" }
  };

  // Months array
  const months = [
    { key: "January", label: translation?.i18n?.language === "al" ? translation.t("jan") : "January" },
    { key: "February", label: translation?.i18n?.language === "al" ? translation.t("feb") : "February" },
    { key: "March", label: translation?.i18n?.language === "al" ? translation.t("mar") : "March" },
    { key: "April", label: translation?.i18n?.language === "al" ? translation.t("apr") : "April" },
    { key: "May", label: translation?.i18n?.language === "al" ? translation.t("may") : "May" },
    { key: "June", label: translation?.i18n?.language === "al" ? translation.t("jun") : "June" },
    { key: "July", label: translation?.i18n?.language === "al" ? translation.t("jul") : "July" },
    { key: "August", label: translation?.i18n?.language === "al" ? translation.t("aug") : "August" },
    { key: "September", label: translation?.i18n?.language === "al" ? translation.t("sep") : "September" },
    { key: "October", label: translation?.i18n?.language === "al" ? translation.t("oct") : "October" },
    { key: "November", label: translation?.i18n?.language === "al" ? translation.t("nov") : "November" },
    { key: "December", label: translation?.i18n?.language === "al" ? translation.t("dec") : "December" }
  ];

  // Filter countries for nationality
  const filteredCountries = useMemo(() => {
    const priorityCountries = ['XK', 'AL']; // Kosovo and Albania
    
    const filtered = countriesData.filter(country => 
      country.name.common.toLowerCase().includes(nationalitySearchQuery.toLowerCase())
    );

    return filtered.sort((a, b) => {
      const aIndex = priorityCountries.indexOf(a.cca2);
      const bIndex = priorityCountries.indexOf(b.cca2);
      
      if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      
      return a.name.common.localeCompare(b.name.common);
    });
  }, [nationalitySearchQuery]);

  // Filter phone countries
  const filteredPhoneCountries = useMemo(() => {
    const priorityCountries = ['XK', 'AL'];
    
    return Object.entries(extendedCountryTelData)
      .filter(([code, data]) => 
        data.name.toLowerCase().includes(phoneCountrySearchQuery.toLowerCase()) ||
        data.dial_code.includes(phoneCountrySearchQuery) ||
        code.toLowerCase().includes(phoneCountrySearchQuery.toLowerCase())
      )
      .sort((a, b) => {
        const aIndex = priorityCountries.indexOf(a[0]);
        const bIndex = priorityCountries.indexOf(b[0]);
        
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        
        return a[1].name.localeCompare(b[1].name);
      });
  }, [phoneCountrySearchQuery]);

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (nationalityDropdownRef.current && !nationalityDropdownRef.current.contains(event.target)) {
        setIsNationalityOpen(false);
      }
      if (birthMonthDropdownRef.current && !birthMonthDropdownRef.current.contains(event.target)) {
        setIsBirthMonthOpen(false);
      }
      if (expiryMonthDropdownRef.current && !expiryMonthDropdownRef.current.contains(event.target)) {
        setIsExpiryMonthOpen(false);
      }
      if (phoneCountryDropdownRef.current && !phoneCountryDropdownRef.current.contains(event.target)) {
        setIsPhoneCountryOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Override default blue focus border globally for this page
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.textContent = `
      input:focus, select:focus, textarea:focus {
        border-color: #E5E9F2 !important;
        box-shadow: 0 0 0 2px rgba(0,0,0,0.05) !important;
        outline: none !important;
      }
    `;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  useEffect(() => {
    if (!addPassengerDetails.length) {
      const generateAddPassengerList = {
        adults: {
          visible: false,
          total: adult,
        },
        children: {
          visible: false,
          total: children,
        },
        infants: {
          visible: false,
          total: babies,
        },
      };
      setAddPassengerDetails(generateAddPassengerList || []);
    }
  }, [
    addPassengerDetails.length,
    adult,
    babies,
    children,
    currentTotalPassengers,
  ]);

  const {
    price,
    bookingFlightDetails,
    handBagDimensions,
    holdBagDimensions,
    holdBagsToPay,
    setPrice,
    baggageInfo,
    loading: priceLoading,
    error: priceError,
  } = useCheckFlight(
    flight,
    currency,
    adult,
    children,
    babies,
    flight?.bnum || baggage?.cabin + baggage?.checked || 0
  );
  let totalBaggFinal = useStoreFly((state) => state.ancillary)

  function dateFormat(date) {
    let splitdate = date.split('-')
    return splitdate[2] + '-' + splitdate[1] + '-' + splitdate[0]
  }
  function returnAncillaries(passagers) { 
    let finalAncillary = []
    let bags = totalBaggFinal
    let allData = []
    if (localStorage.getItem('ancillaryData') !== "undefined") {
      allData = JSON.parse(localStorage.getItem('ancillaryData'))
    }
    let passagerIds = []
    passagerIds = bags.map((el) => el.id)
    passagerIds = passagerIds.reduce(
      (unique, item) => (unique.includes(item) ? unique : [...unique, item]),
      [],
    );


    let finalBags = []

    bags.forEach((bag) => {
      allData.forEach((data) => {
        data.ancillary.ancillaries.baggage.forEach((ancBag) => {
          if (bag.ancillary.ancillaryKey === ancBag.ancillaryKey) {
            // ancBag.baggagePiece = 1;
            let obj = {
              ...ancBag,

              ancillaryJourneys: data.ancillary.journeys
            }
            if (!obj.description) {
              obj.description = 'test'
            }
            let pass = passagers[bag.id - 1] 
            let passObj = {
              "firstName": pass.firstName?pass.firstName:pass.name,
              "lastName": pass.lastName?pass.lastName:pass.surname,
              "psgType": pass.category==='adult'?'ADT':pass.category==='child'?'CHD':'INF',
              // "sex": pass.sex
            }
            finalAncillary.push({
              ancillaries: {
                baggage: [obj]
              },
              ancillaryPassenger: passObj
            })
          }
        })

      })
    })
    const mergeBaggage = (data) => {
      const passengerMap = {};

      data.forEach(item => {
        const { firstName, lastName } = item.ancillaryPassenger;
        const key = `${firstName} ${lastName}`;

        if (!passengerMap[key]) {
          passengerMap[key] = {
            ...item,
            ancillaries: {
              baggage: []
            }
          };
        }

        passengerMap[key].ancillaries.baggage = passengerMap[key].ancillaries.baggage.concat(item.ancillaries.baggage);
      });

      return Object.values(passengerMap);
    };


    return mergeBaggage(finalAncillary)

  }
  function returnFinalBagg(bags = []) {
    let price = 0;
    if (bags && bags.length > 0) {
      bags.forEach((el) => {
        price += el.ancillary.baggagePrice
      })
    }
    return Number(price)
  }

  const [currentPrice, setCurrentPrice] = useState(price || flight?.totalPrice || 0);
  
  // Update currentPrice when price from useCheckFlight changes or when flight has initial totalPrice
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // Price update check
    }
    
    if (price && price > 0) {
      // Price from precise pricing API - this is the most accurate
      if (process.env.NODE_ENV === 'development') {
        // Updating price from useCheckFlight hook (precise pricing)
      }
      setCurrentPrice(price);
    } else if (flight?.totalPrice && flight.totalPrice > 0 && (!price || price === 0)) {
      // Use the flight's initial totalPrice if available and no precise pricing yet
      if (process.env.NODE_ENV === 'development') {
        // Using flight initial totalPrice
      }
      setCurrentPrice(flight.totalPrice);
    } else if (priceError && flight?.totalPrice && flight.totalPrice > 0) {
      // Use flight total price as fallback
      if (process.env.NODE_ENV === 'development') {
        // Fallback to flight initial totalPrice due to pricing error
      }
      setCurrentPrice(flight.totalPrice);
    }
  }, [price, flight?.totalPrice, currentPrice, priceLoading, priceError]);
  
  const [firstPrice, secondPrice] = formatPrice(
    addPercentageToPrice(returnFinalBagg(totalBaggFinal) + (currentPrice || price))
  );
  const [passengersPriceFirst, passengerPriceSecond] = formatPrice(
    addPercentageToPrice(currentPrice || price)
  );

  const {
    airlineOutbound,
    airlineInbound,
    ibCityCodeFrom,
    ibCityCodeTo,
    obCityCodeTo,
    obCityFrom,
    obCityTo,
    obArrivalTime,
    obDepartureTime,
    obCityCodeFrom,
    obMinutes,
    obHours,
    obStops,
    ibArrivalTime,
    ibDepartureTime,
    ibHours,
    ibMinutes,
    ibStops,
    obLocalDep,
    obLocalArr,
    ibLocalDep,
    ibLocalArr,
  } = FlightUtil.flightDetailsByFlight(flight, carriers);



  useEffect(() => {
    const timer = setTimeout(() => {
      setFreshPriceDialog(true)
      
    }, 300000); // after 5 minutes

    const getCountries = async () => {
       try {
         // Add timeout to prevent hanging on slow API responses
         const timeoutPromise = new Promise((_, reject) =>
           setTimeout(() => reject(new Error('API timeout')), 10000)
         );
         
         const data = await Promise.race([
           GET(GET_LIST_COUNTRY_ALL).catch(() => null), // swallow 4xx/5xx errors
           timeoutPromise
         ]);
      const favCountries = [];
      data?.forEach((c) => {
        if (c.name.common === "Kosovo" || c.name.common === "Albania") {
          favCountries.push({
            name: c?.name?.common,
            code: c?.cca2,
          });
        }
      });
      const otherCountries = data
        ?.map((country) => ({
          name: country?.name?.common,
          code: country?.cca2,
        }))
        .filter((x) => x.name !== "Kosovo" && x.name !== "Albania");
      setCountries([...favCountries, ...otherCountries]);
      return data;
             } catch (error) {
         // Failed to fetch countries from API, using local data as fallback.
         // Log only in development to avoid noisy runtime error in production.
         if (process.env.NODE_ENV === 'development') {
           console.error('Error fetching country list:', error);
         }
         const favCountries = [];
         countriesData?.forEach((c) => {
           if (c.name.common === "Kosovo" || c.name.common === "Albania") {
             favCountries.push({
               name: c?.name?.common,
               code: c?.cca2,
             });
           }
         });
         const otherCountries = countriesData
           ?.map((country) => ({
             name: country?.name?.common,
             code: country?.cca2,
           }))
           .filter((x) => x.name !== "Kosovo" && x.name !== "Albania");
         
         const fallbackCountries = [...favCountries, ...otherCountries];
         setCountries(fallbackCountries);
         return fallbackCountries;
      }
    };
    getCountries();
    return () => {
      clearTimeout(timer);
    }
  }, []);

  let finalBagg = (useStoreFly((state) => state.ancillary))
  const setAddedBaggageHandler = (newBaggage, id, action) => {
    if (action === "remove") {
      const itemToRemove = addedBaggage?.find(
        (baggage) => baggage.id === id && baggage.price === newBaggage?.price
      );
      const baggages = addedBaggage?.filter((b) => b.id !== itemToRemove?.id);
      const updatedItem = [
        {
          id,
          type: "Checked Baggage",
          price: Number(totalBaggagePrice) - Number(itemToRemove?.price),
          currency: CURRENCY_SIGN[currency?.curr],
        },
      ];
      setAddedBaggage(baggages);
      setTotalBaggagePrice(
        Number(totalBaggagePrice) - Number(itemToRemove?.price)
      );
      setNewBaggageItem(updatedItem);
    }

    if (action === "add") {
      const totalBaggage = [...addedBaggage, ...newBaggage];
      const totalBaggagePrice = totalBaggage
        ?.map((baggage) => baggage.price)
        .reduce((acc, price) => {
          return Number(acc) + Number(price);
        }, 0);
      const item = [
        {
          id,
          type: "Checked Baggage",
          price: totalBaggagePrice,
          currency: CURRENCY_SIGN[currency?.curr],
        },
      ];
      setAddedBaggage([...addedBaggage, ...newBaggage]);
      setTotalBaggagePrice(totalBaggagePrice);
      setNewBaggageItem(item);
    }
  };

  const removeWhenNoCheckedBaggage = (id, bags) => {
    const bnum = getItemFromLocalStorage("bnum");
    const quantity = bags?.find((el) => el.id === id)?.quantity;
    if (quantity) {
      localStorage.setItem(
        "bnum",
        JSON.stringify({
          ...bnum,
          checked: bnum?.checked - quantity,
        })
      );
    }
    const [{ price }] = finalBagg?.length
      ? finalBagg
      : [{ price: 0 }];
    const baggages = finalBagg;
    const totalBaggagePrice = baggages
      ?.map((baggage) => baggage.ancillary.baggagePrice)
      .reduce((acc, price) => {
        return Number(acc) + Number(price);
      }, 0);
    const updatedBaggages = addedBaggage;
    const updatedItem = [
      {
        id,
        type: "Checked Baggage",
        price: price - Number(totalBaggagePrice),
        currency: CURRENCY_SIGN[currency?.curr],
      },
    ];

    setAddedBaggage(updatedBaggages);
    setTotalBaggagePrice(price - Number(totalBaggagePrice));
    setNewBaggageItem(updatedItem);
  };

  const submitBooking = async () => {
    try {
      setBookingLoading(true);
      setDisableBookingButton(true);

      await formRef.validateFields();

      if (!formRef.isValid()) {
        setBookingLoading(false);
        setDisableBookingButton(false);

        if (!formRef.isValid()) {
          const errorFields = formRef.fieldsStore.fields;
          const firstError = errorFields?.find(
            (errField) =>
              errField.validations[0].type === "error" &&
              errField.validations[0].show
          );

          if (firstError) {
            firstError.element.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
        return;
      }

      setRedirectMessage(
        "Please wait for a few seconds while we verify your information"
      );
      setMessageSeverity("info");
      setShowRedirectMessage(true);
      const bnum = getItemFromLocalStorage("bnum");


      await sendBookingRequest()

      const response = JSON.parse(localStorage.getItem('preciseBookingOrder'))
      // const response = await GET( 
      //   `${BOOKING_CHECK_FLIGHT}?booking_token=${flight?.booking_token}&bnum=${bnum?.checked || 0
      //   }&adults=${adult}&children=${children}&infants=${babies}&currency=${currency?.curr
      //   }`,
      //   {},
      //   ITRAVEL_KEY_API
      // );

      if (
        response === 'undefined'
      ) {
        alert(
          "This flight is invalid and has expired",
          navigate("/")
        );
        setCurrentPrice(addPercentageToPrice(response?.total));
      }
      // Processing booking data
      const passengerList =
        passengersList?.map((p) =>
          passengerDetailsForBooking({
            ...p.form,
            category: p.passengerType,
            email: "info@fluturolire.com", // SENDER_EMAIL
            phone: mainPassengerForm?.phone,
          })
        ) || [];

      const passengersToBook = [
        passengerDetailsForBooking(mainPassengerForm),
        ...passengerList,
      ];

      const bookingDetails = passengerBaggageForBooking(
        passengersToBook,
        {
          combinations: response?.baggage?.combinations || [],
          definitions: response?.baggage?.definitions || [],
        },
        addedBaggage,
        flight?.bnum
      );
      const currentStorageBooking = getItemFromLocalStorage("currentBooking");
      const currentBookingToken = flight?.booking_token || currentStorageBooking?.booking_token;

      // const bookingResponse = await FlightUtil.saveBooking(
      //   "en",
      //   "en",
      //   bookingDetails?.passengers,
      //   currentBookingToken,
      //   response?.session_id,
      //   bookingDetails?.baggage
      // );

      if (response === 'undefined') {
        setMessageSeverity("error");
        setRedirectMessage(
          "Error while saving booking. Please try again and check if you have enter your information correctly!"
        );
        setShowRedirectMessage(true);
        setBookingLoading(false);
        setDisableBookingButton(false);
      }

      if (
        response !== 'undefined'
      ) {
        const passengersList = encodeURIComponent(
          JSON.stringify(passengerList)
        );
        function createBookingId(orderNum) {
          let a = orderNum.slice(0, 8)
          let b = orderNum.slice(9, 17)
          return Number(a) + Number(b)
        }
        //  ${FLUTURO_LIRE_REDIRECT}?email=${mainPassengerForm?.email}&booking_id=${bookingResponse?.booking_id}&transaction_id=${bookingResponse?.transaction_id}&name=${mainPassengerForm?.name}&from_destination=${obCityFrom}&to_destination=${obCityTo}&booking_token=${currentBookingToken}`
        response.data.bookingId = createBookingId(response.data.orderNum)
        const u = MAIN_LAMBDA + '/accept-teb-final-ok'
        const uf = MAIN_LAMBDA + '/accept-teb-final-fail'
        const okUrl = `${u}?email=${mainPassengerForm?.email}&name=${mainPassengerForm?.name}&orderNum=${response.data.orderNum}&bookingId=${response.data.bookingId}&telNum=${mainPassengerForm?.phone}&PNR=${response.data.pnr}/`;
        const failUrl = `${uf}?email=${mainPassengerForm?.email}&name=${mainPassengerForm?.name}&bookingId=${response.data.bookingId}&orderNum=${response.data.orderNum}&telNum=${mainPassengerForm?.phone}&PNR=${response.data.pnr}/`;
        await POST(`${MAIN_LAMBDA}/saveBookingResponse`, {
          body: JSON.stringify({
            ...response,
            name: mainPassengerForm?.name,
            lastName: mainPassengerForm?.surname,
            email: mainPassengerForm?.email,
            from_destination: obCityFrom,
            to_destination: obCityTo,
            booking_token: currentBookingToken,
          }),
        });

        if (response !== 'undefined') {
          setMessageSeverity("success");
          setRedirectMessage("Redirecting to payment page!");
          setShowRedirectMessage(true);
        }
        // Payment URL ready
        await goToTebPaymentPage(
          addPercentageToPrice(totalBaggagePrice + currentPrice).toString(),
          currency?.curr,
          okUrl,
          // okUrl,
          failUrl,
          setBookingLoading,
          setDisableBookingButton
        );
      }
    } catch (error) {
      // Error occurred during booking process
      setMessageSeverity("error");
      setRedirectMessage("Something went wrong. Please try again!");
      setBookingLoading(false);
      setDisableBookingButton(false);
      setShowRedirectMessage(true);
    }
  };
  const [currentImage, setCurrentImage] = useState("");
  useEffect(() => {
    const getCityToImage = async () => {
      try {
        const response = await GET(
          `https://api.teleport.org/api/urban_areas/slug:${flight.cityTo?.toLowerCase()}/images/`
        );
        const imageUrl = response?.photos[0]?.image?.web;
        setCurrentImage(imageUrl);
      } catch (error) {
        // Failed to fetch city image
        // Set a default image or leave empty
        setCurrentImage(null);
      }
    };
    
    if (flight?.cityTo) {
      getCityToImage();
    }
  }, [flight?.cityTo]);
  const mobileAirlineDimensions = window.innerWidth < 801 ? "32x32" : "32x32";

  // TODO Mi shfaq krejt routes depart and return jo veq tparen edhe te fundit
  // me shfaq flight number afer logos Flight edhe numri
  // te PRN MILAN mi shfaq emrin e aeroportit edhe te dita me shfaq diten edhe daten psh Wednesday Oct 04

  async function sendBookingRequest() {
    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Apifox/1.0.0 (https://apifox.com)");
    myHeaders.append("Content-Type", "application/json");
    let finalFlight = localStorage.getItem('preciseSearchData')?(JSON.parse(localStorage.getItem('preciseSearchData'))[0]):undefined
    // Processing final flight data

    finalFlight?.journeys?.journey_0?.segmentIds?.forEach((seg) => {
      // "airline": "FD",
      //           "flightNum": "503",
      //           "arrival": "DMK",
      //           "arrivalDate": "2024-12-31",
      //           "arrivalTime": "00:20",
      //           "departure": "HKG",
      //           "departureDate": "2024-12-30",
      //           "departureTime": "22:20",
      //           "bookingCode": "A"
      delete seg.isReturn
      delete seg.fareBasis
      delete seg.stopover
      delete seg.opFltAirline
      delete seg.opFltNo
      delete seg.codeShare
      delete seg.stayTime
      delete seg.flightTime
      delete seg.arrivalTerminal
      delete seg.departureTerminal
      delete seg.availabilityCount
      // delete seg.bookingCode
      delete seg.cabinClass
      delete seg.equipment
      delete seg.segmentId
      seg.arrivalDate = seg.strArrivalDate
      seg.departureDate = seg.strDepartureDate
      seg.arrivalTime = seg.strArrivalTime
      seg.departureTime = seg.strDepartureTime
      delete seg.strArrivalDate
      delete seg.strDepartureDate
      delete seg.strArrivalTime
      delete seg.strDepartureTime
      delete seg.ancillary
      delete seg.baggageInfo
    })
    finalFlight?.journeys?.journey_1?.segmentIds?.forEach((seg) => {
      // "airline": "FD",
      //           "flightNum": "503",
      //           "arrival": "DMK",
      //           "arrivalDate": "2024-12-31",
      //           "arrivalTime": "00:20",
      //           "departure": "HKG",
      //           "departureDate": "2024-12-30",
      //           "departureTime": "22:20",
      //           "bookingCode": "A"
      delete seg.isReturn
      delete seg.fareBasis
      delete seg.stopover
      delete seg.opFltAirline
      delete seg.opFltNo
      delete seg.codeShare
      delete seg.stayTime
      delete seg.flightTime
      delete seg.arrivalTerminal
      delete seg.departureTerminal
      delete seg.availabilityCount
      // delete seg.bookingCode
      delete seg.cabinClass
      delete seg.equipment
      delete seg.segmentId
      seg.arrivalDate = seg.strArrivalDate
      seg.departureDate = seg.strDepartureDate
      seg.arrivalTime = seg.strArrivalTime
      seg.departureTime = seg.strDepartureTime
      delete seg.strArrivalDate
      delete seg.strDepartureDate
      delete seg.strArrivalTime
      delete seg.strDepartureTime
      delete seg.ancillary
      delete seg.baggageInfo
    })
    const passengerList =
      passengersList?.map((p) =>
        passengerDetailsForBooking({
          ...p.form,
          category: p.passengerType,
          email: "info@fluturolire.com", // SENDER_EMAIL
          phone: mainPassengerForm?.phone,
        })
      ) || [];
    const passengersToBook = [
      passengerDetailsForBooking(mainPassengerForm),
      ...passengerList,
    ]; 

    function returnPassagers(passagers = []) {
      let a = passagers
      let arr = []
      a.forEach((el) => {
        arr.push(
          {
          firstName: el.name,
          nationality: el.nationality,
          lastName: el.surname,
          psgType: el.category==='adult'?'ADT':el.category==='child'?'CHD':'INF',
          sex: el.title === 'mr' ? 'M' : 'F',
          birthday: moment(el.birthday).format('YYYY-MM-DD')
      })
    })
    return arr
  }





  var raw = JSON.stringify({
    "authentication": {
      "sign": SIGNATURE,
      "partnerId": PARTNERID
    },
    "booking": {
      "passengers": returnPassagers(passengersToBook),
      "solution": {
        "adtFare": finalFlight.adtFare,
        "solutionId": finalFlight.solutionId,
        "adtTax": finalFlight.adtTax,
        "chdFare": finalFlight.chdFare,
        "chdTax": finalFlight.chdTax,
        "infFare": finalFlight.infFare ? finalFlight.infFare : 0,
        "infTax": finalFlight.infTax ? finalFlight.infTax : 0,
        "journeys": {
          journey_0:
            finalFlight.journeys.journey_0.segmentIds
          ,
          journey_1:
            finalFlight.journeys.journey_1?.segmentIds
        }

      },
      "ancillary": returnAncillaries(passengersToBook)
    }
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  await fetch(MAIN_LAMBDA + "/precise-booking", requestOptions)
    .then(response => response.json())
    .then(async result => {
      localStorage.setItem('preciseBookingOrder', JSON.stringify(result))

       
    })
    .catch(error => {
      // Error occurred during booking
    });




}

  // Safely get flight data with null checking - after all hooks are called
  let flightData = flight;
  if (!flightData) {
    try {
      const storedBooking = localStorage.getItem('currentBooking');
      flightData = storedBooking ? JSON.parse(storedBooking) : null;
    } catch (error) {
      console.error('Error parsing stored booking:', error);
      flightData = null;
    }
  }

  // Conditional render - show loading if no flight data is available
  if (!flightData) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px',
        flexDirection: 'column',
        gap: '16px'
      }}>
        <div style={{ color: '#003663', fontSize: '1.2rem', fontWeight: '600' }}>
          Loading flight details...
        </div>
        <div style={{ color: '#666', fontSize: '1rem' }}>
          Please wait while we load your booking information.
        </div>
      </div>
    );
  }

  // Use the validated flight data
  flight = flightData;
  
  // Debug: Log the flight data structure (development only)
  if (process.env.NODE_ENV === 'development') {
    // Flight data received for processing
  }

return (
  <section style={{
    width: "100%",
    backgroundColor: "#f8f9fa",
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: "40px"
  }}>
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
      {/* Modern Header */}
      <div style={{
        ...cardStyle,
        marginBottom: "40px",
        textAlign: isMobile ? "center" : "left",
        // Ensure full rounded corners on mobile, consistent with standard SSL header card design
        borderRadius: isMobile ? "16px" : cardStyle.borderRadius
      }}>
        <div style={blendOverlayStyle} />
        <div style={{ position: "relative", zIndex: 2 }}>
          <div style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isMobile ? "center" : "center",
            gap: isMobile ? "16px" : "0"
          }}>
            <h2 style={{
              margin: 0,
              color: primaryColor,
              fontSize: isMobile ? '1.5rem' : '1.8rem',
              fontWeight: 600,
              textAlign: 'left'
            }}>
              {translation.t("nearly_done")}: {translation.t("add_passenger_details")}
              </h2>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: isMobile ? 'center' : 'flex-end',
              gap: '0.75rem',
              color: primaryColor,
              fontSize: isMobile ? '0.95rem' : '1rem',
              fontWeight: 500,
              textAlign: 'right',
              flexWrap: 'nowrap'
            }}>
              {(() => {
                const full = translation.t("ssl");
                const breakpoint = full.indexOf(" always");
                const first = breakpoint !== -1 ? full.slice(0, breakpoint) : full;
                const second = breakpoint !== -1 ? full.slice(breakpoint + 1) : "";
                return (
                  <span style={{ lineHeight: 1.4, textAlign: 'right', display: 'inline-block' }}>
                    {first}
                    <br />
                    {second}
                  </span>
                );
              })()}
              {/* SSL Icon */}
              <img
                src={sslIcon}
                alt="SSL Secure"
                style={{ width: isMobile ? 60 : 65, height: isMobile ? 60 : 65 }}
              />
            </div>
          </div>
        </div>
      </div>

       {/* Passenger Details Info */}
       <div style={{
         ...cardStyle,
         marginBottom: "40px",
         display: "flex",
         alignItems: "flex-start",
         gap: "16px"
       }}>
         <div style={blendOverlayStyle} />
         <div style={{ position: "relative", zIndex: 2, display: "flex", alignItems: "flex-start", gap: "16px", width: "100%" }}>
           <img 
             src={passport} 
             alt="passport" 
             style={{ width: "54px", height: "54px", flexShrink: 0 }}
           />
           <div>
             <h3 style={{
               color: primaryColor,
               fontSize: "1.2rem",
               fontWeight: "600",
               margin: "0 0 8px 0"
             }}>
                  {translation.t("passenger_details")}
             </h3>
             <p style={{
               color: primaryColor,
               fontSize: "1rem",
               margin: 0,
               lineHeight: "1.5"
             }}>
               {translation.t("given_info")}
              </p>
            </div>
          </div>
        </div>

       {/* Main Content Layout */}
       <div style={{
         display: "flex",
         flexDirection: isMobile ? "column" : "row",
         gap: "40px",
         alignItems: "flex-start",
         paddingBottom: isMobile ? "0" : "60px" /* further trimmed for tighter spacing */
       }}>
         {/* Left Column - Forms */}
         <div style={{
           flex: isMobile ? "1" : "2",
           width: isMobile ? "100%" : "auto"
         }}>
           {/* Trip Summary */}
           <div style={{
             ...cardStyle,
             marginBottom: "40px"
           }}>
             <div style={blendOverlayStyle} />
             <div style={{ position: "relative", zIndex: 2 }}>
               <h4 style={{
                 color: primaryColor,
                 fontSize: "1.3rem",
                 fontWeight: "600",
                 margin: "0 0 24px 0"
                               }}>
                  {translation.t("trip_summary")}
                </h4>
              {flight.journeys?.journey_0?.segmengtIds?.map((r) => {
                if (!r.isReturn) {
                  return (
                    <TripSummaryItem
                      flight={flight}
                      route={r}
                      translation={translation}
                      carriers={carriers}
                      type={"depart"}
                    />
                  );
                }
                return null;
              })}
              {flight.journeys?.journey_1?.segmengtIds?.map((r) => {
                if (r.isReturn) {
                  return (
                    <TripSummaryItem
                      flight={flight}
                      route={r}
                      translation={translation}
                      carriers={carriers}
                      type={"return"}
                    />
                  );
                }
                return null;
              })}

              {returnOrOneWay === "return" &&
                flight?.route?.map((r) => {
                  if (r && r.return === 1) {
                    return (
                      <TripSummaryItem
                        flight={flight}
                        route={r}
                        translation={translation}
                        carriers={carriers}
                        type={"return"}
                      />
                    );
                  }
                  return null;
                })}
            </div>
          </div>

            {/* Passenger Form */}
            <div style={{
              ...cardStyle,
              marginBottom: "40px"
            }}>
              <div style={blendOverlayStyle} />
              <div style={{ position: "relative", zIndex: 2 }}>
            <FormWithConstraints
              ref={(form) => {
                if (form) {
                  setFormRef(form);
                }
              }}
              noValidate
            >
                  <h4 style={{
                    color: primaryColor,
                    fontSize: "1.3rem",
                    fontWeight: "600",
                    margin: "0 0 32px 0"
                  }}>
                    {translation.t("passenger_details")}
                  </h4>

                  {/* Title Selection */}
                  <div style={{ marginBottom: "32px" }}>
                    <div className="col-lg-12 d-flex mb-4 col-md-12 col-12">
                      <div className="custom-control custom-radio custom-control border-bottom-0 tick col-auto">
                  <input
                    type="radio"
                    id="customRadio-filter-Mr"
                    value="mr"
                    required
                    name="customRadio"
                          className="pointer custom-control-input"
                    onChange={(event) => {
                      formRef.validateFields(event.target);
                      setMainPassengerForm({
                        ...mainPassengerForm,
                        title: event.target.value,
                      });
                    }}
                    defaultChecked="mr"
                  />
                  <label
                          className="custom-control-label d-flex align-items-center"
                          htmlFor="customRadio-filter-Mr"
                  >
                    {translation.t("mr")}
                  </label>
                </div>
                      <div className="custom-control custom-radio custom-control border-bottom-0 tick col-auto">
                  <input
                    type="radio"
                    id="customRadio-filter-Ms"
                    name="customRadio"
                          className="pointer custom-control-input"
                    value="ms"
                    onChange={(event) => {
                      formRef.validateFields(event.target);
                      setMainPassengerForm({
                        ...mainPassengerForm,
                        title: event.target.value,
                      });
                    }}
                  />
                  <label
                          className="custom-control-label d-flex align-items-center"
                          htmlFor="customRadio-filter-Ms"
                  >
                    {translation.t("ms")}
                  </label>
                </div>
              </div>
                  </div>

                  {/* Name Fields */}
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                    gap: "24px",
                    marginBottom: "24px"
                  }}>
                    <div>
                      <label style={formLabelStyle(false)}>
                        {translation.t("first_name")}
                      </label>
                    <input
                      type="text"
                      name="first_name"
                        style={inputStyle}
                      pattern="[A-Za-z]+"
                      required
                        placeholder={translation.t("first_name")}
                      onChange={(event) => {
                        setMainPassengerForm({
                          ...mainPassengerForm,
                          name: event.target.value,
                        });
                        formRef.validateFields(event.target);
                      }}
                    />
                    <FieldFeedbacks for="first_name">
                      <FieldFeedback when="*">
                        {translation.t("enter_first_name")}
                      </FieldFeedback>
                    </FieldFeedbacks>
                  </div>
                    <div>
                      <label style={formLabelStyle(false)}>
                        {translation.t("last_name")}
                      </label>
                    <input
                      type="text"
                      name="surname"
                        style={inputStyle}
                      pattern="[A-Za-z]+"
                      required
                        placeholder={translation.t("last_name")}
                      onChange={(event) => {
                        setMainPassengerForm({
                          ...mainPassengerForm,
                          surname: event.target.value,
                        });
                        formRef.validateFields(event.target);
                      }}
                    />
                    <FieldFeedbacks for="surname">
                        <FieldFeedback when="*">
                        {translation.t("enter_last_name")}
                      </FieldFeedback>
                    </FieldFeedbacks>
                  </div>
                  </div>

                  {/* Date of Birth */}
                  <div style={{ marginBottom: "24px" }}>
                    <label style={formLabelStyle(false)}>
                      {translation.t("date_of_birth")}
                    </label>
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 2fr 1fr",
                      gap: "12px"
                    }}>
                        <input
                          type="number"
                        style={inputStyle}
                        placeholder={translation.t("DD")}
                          name="date_of_birth"
                          min={1}
                          required
                          onChange={(event) => {
                            setMainPassengerForm({
                              ...mainPassengerForm,
                              dayOfBirth: event.target.value,
                            });
                            formRef.validateFields(event.target);
                          }}
                        />
                      <div style={{ position: 'relative' }} ref={birthMonthDropdownRef}>
                        <div 
                          onClick={() => setIsBirthMonthOpen(!isBirthMonthOpen)}
                          style={{
                            ...inputStyle,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer'
                          }}
                        >
                          <span>
                            {selectedBirthMonth || translation.t("Month")}
                          </span>
                          <svg 
                            width="12" 
                            height="12" 
                            viewBox="0 0 16 16"
                            style={{
                              transform: isBirthMonthOpen ? 'rotate(180deg)' : 'rotate(0)',
                              transition: 'transform 0.2s ease'
                            }}
                          >
                            <path 
                              fill="none" 
                              stroke="currentColor" 
                              strokeLinecap="round" 
                              strokeLinejoin="round" 
                              strokeWidth="2" 
                              d="M2 5l6 6 6-6"
                            />
                          </svg>
                      </div>
                        
                        {isBirthMonthOpen && (
                          <div 
                          style={{
                              position: 'absolute',
                              top: '100%',
                              left: '0',
                              backgroundColor: '#fff',
                              borderRadius: '12px',
                              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                              zIndex: 9999999999,
                              width: '100%',
                              maxHeight: '300px',
                              overflow: 'hidden',
                              border: '1px solid #E5E9F2',
                              marginTop: '4px'
                            }}
                          >
                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                              {months.map((month) => (
                                <div
                                  key={month.key}
                                  onClick={() => {
                                    setSelectedBirthMonth(month.label);
                            setMainPassengerForm({
                              ...mainPassengerForm,
                                      monthOfBirth: month.key,
                                    });
                                    setIsBirthMonthOpen(false);
                                  }}
                                  style={{
                                    padding: '12px 16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease-in-out',
                                    backgroundColor: selectedBirthMonth === month.label ? '#003663' : 'transparent',
                                    color: selectedBirthMonth === month.label ? '#fff' : '#1a1a1a',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                  }}
                                  onMouseEnter={(e) => {
                                    if (selectedBirthMonth !== month.label) {
                                      e.currentTarget.style.backgroundColor = '#F0F7FF';
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (selectedBirthMonth !== month.label) {
                                      e.currentTarget.style.backgroundColor = 'transparent';
                                    }
                                  }}
                                >
                                  {month.label}
                      </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                        <input
                          type="number"
                        style={inputStyle}
                          required
                          name="year_of_birth"
                        placeholder={translation.t("year")}
                          onChange={(event) => {
                            setMainPassengerForm({
                              ...mainPassengerForm,
                              yearOfBirth: event.target.value,
                            });
                            formRef.validateFields(event.target);
                          }}
                        />
                    </div>
                    <FieldFeedbacks for="date_of_birth">
                      <FieldFeedback when="*" />
                    </FieldFeedbacks>
                        <FieldFeedbacks for="year_of_birth">
                          <FieldFeedback when="*" />
                        </FieldFeedbacks>
                      </div>

                  {/* Nationality & Passport / ID (new row) */}
                  <div
                    style={{
                      display: isMobile ? 'block' : 'grid',
                      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                      gap: '24px',
                      marginBottom: '24px',
                    }}
                  >
                    {/* Nationality trigger – uses existing dropdown logic */}
                    <div>
                      <label style={formLabelStyle(false)}>{translation.t('nationality')}</label>
                      <div
                        style={{ position: 'relative' }}
                        ref={nationalityDropdownRef}
                      >
                        <div
                          onClick={() => setIsNationalityOpen(!isNationalityOpen)}
                          style={{
                            ...inputStyle,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                          }}
                        >
                          <span>
                            {selectedNationality || translation.t('Select nationality')}
                          </span>
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 16 16"
                            style={{
                              transform: isNationalityOpen ? 'rotate(180deg)' : 'rotate(0)',
                              transition: 'transform 0.2s ease',
                            }}
                          >
                            <path
                              fill="none"
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M2 5l6 6 6-6"
                            />
                          </svg>
                        </div>
                        {isNationalityOpen && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              backgroundColor: '#fff',
                              borderRadius: '12px',
                              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                              zIndex: 9999999999,
                              width: '350px',
                              maxWidth: '90vw',
                              maxHeight: '500px',
                              overflow: 'hidden',
                              border: '1px solid #E5E9F2',
                              marginTop: '4px'
                            }}
                          >
                            <div style={{ padding: '16px', borderBottom: '1px solid #eef1f5' }}>
                              <input
                                type="text"
                                value={nationalitySearchQuery}
                                onChange={(e) => setNationalitySearchQuery(e.target.value)}
                                placeholder={translation.t('Search country...')}
                                style={{
                                  ...inputStyle,
                                  height: '44px',
                                  boxShadow: 'none',
                                  border: '1px solid #eef1f5'
                                }}
                                onClick={(e) => e.stopPropagation()}
                                autoFocus
                              />
                            </div>
                            <div style={{ maxHeight: '440px', overflowY: 'auto' }}>
                              {filteredCountries.map((country) => (
                                <div
                                  key={country.cca2}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedNationality(country.name.common);
                                    setMainPassengerForm({
                                      ...mainPassengerForm,
                                      nationality: country.cca2,
                                    });
                                    setIsNationalityOpen(false);
                                    setNationalitySearchQuery('');
                                  }}
                                  style={{
                                    padding: '14px 18px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    transition: 'background-color 0.2s',
                                    backgroundColor: selectedNationality === country.name.common ? '#003663' : 'transparent',
                                    color: selectedNationality === country.name.common ? '#fff' : '#1a1a1a',
                                    fontSize: '15px',
                                    fontWeight: 500,
                                    borderBottom: '1px solid #f0f0f0'
                                  }}
                                  onMouseEnter={(e) => {
                                    if (selectedNationality !== country.name.common) {
                                      e.currentTarget.style.backgroundColor = '#F0F7FF';
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (selectedNationality !== country.name.common) {
                                      e.currentTarget.style.backgroundColor = 'transparent';
                                    }
                                  }}
                                >
                                  <span>{country.name.common}</span>
                                  <img
                                    src={`https://flagcdn.com/w20/${country.cca2.toLowerCase()}.png`}
                                    alt={country.name.common}
                                    style={{ width: 20, height: 15 }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Passport / ID input */}
                    <div>
                      <label style={formLabelStyle(false)}>
                        {translation.t('passaport_id_or_number')}
                      </label>
                      <input
                        type="text"
                        style={inputStyle}
                        required
                        placeholder={translation.t('passaport_id_or_number')}
                        name="passport_or_id_number"
                        onChange={(e) => {
                          setMainPassengerForm({
                            ...mainPassengerForm,
                            cardno: e.target.value,
                          });
                          formRef.validateFields(e.target);
                        }}
                      />
                      <FieldFeedbacks for="passport_or_id_number">
                        <FieldFeedback when="*" />
                      </FieldFeedbacks>
                    </div>
                  </div>

                  {/* Passport Expiry Date */}
                  <div style={{ marginBottom: "24px" }}>
                    <label style={formLabelStyle(false)}>
                        {translation.t("passaport_id_or_number_expiry_date")}
                      </label>
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 2fr 1fr",
                      gap: "12px"
                    }}>
                        <input
                          type="number"
                        style={inputStyle}
                        placeholder={translation.t("DD")}
                          required
                          min={1}
                          name="number_expiry_day"
                          onChange={(event) => {
                            setMainPassengerForm({
                              ...mainPassengerForm,
                              dayOfExpiry: event.target.value,
                            });
                            formRef.validateFields(event.target);
                          }}
                        />
                      <div style={{ position: 'relative' }} ref={expiryMonthDropdownRef}>
                        <div 
                          onClick={() => setIsExpiryMonthOpen(!isExpiryMonthOpen)}
                          style={{
                            ...inputStyle,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer'
                          }}
                        >
                          <span>
                            {selectedExpiryMonth || translation.t("Month")}
                          </span>
                          <svg 
                            width="12" 
                            height="12" 
                            viewBox="0 0 16 16"
                            style={{
                              transform: isExpiryMonthOpen ? 'rotate(180deg)' : 'rotate(0)',
                              transition: 'transform 0.2s ease'
                            }}
                          >
                            <path 
                              fill="none" 
                              stroke="currentColor" 
                              strokeLinecap="round" 
                              strokeLinejoin="round" 
                              strokeWidth="2" 
                              d="M2 5l6 6 6-6"
                            />
                          </svg>
                      </div>
                        
                        {isExpiryMonthOpen && (
                          <div 
                          style={{
                              position: 'absolute',
                              top: '100%',
                              left: '0',
                              backgroundColor: '#fff',
                              borderRadius: '12px',
                              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                              zIndex: 9999999999,
                              width: '100%',
                              maxHeight: '300px',
                              overflow: 'hidden',
                              border: '1px solid #E5E9F2',
                              marginTop: '4px'
                            }}
                          >
                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                              {months.map((month) => (
                                <div
                                  key={month.key}
                                  onClick={() => {
                                    setSelectedExpiryMonth(month.label);
                            setMainPassengerForm({
                              ...mainPassengerForm,
                                      monthOfExpiry: month.key,
                                    });
                                    setIsExpiryMonthOpen(false);
                                  }}
                                  style={{
                                    padding: '12px 16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease-in-out',
                                    backgroundColor: selectedExpiryMonth === month.label ? '#003663' : 'transparent',
                                    color: selectedExpiryMonth === month.label ? '#fff' : '#1a1a1a',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                  }}
                                  onMouseEnter={(e) => {
                                    if (selectedExpiryMonth !== month.label) {
                                      e.currentTarget.style.backgroundColor = '#F0F7FF';
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (selectedExpiryMonth !== month.label) {
                                      e.currentTarget.style.backgroundColor = 'transparent';
                                    }
                                  }}
                                >
                                  {month.label}
                      </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                        <input
                          type="number"
                        style={inputStyle}
                        placeholder={translation.t("year")}
                          required
                          min={new Date().getFullYear()}
                          name="passport_or_id_number_expiry_year"
                          onChange={(event) => {
                            setMainPassengerForm({
                              ...mainPassengerForm,
                              yearOfExpiry: event.target.value,
                            });
                            formRef.validateFields(event.target);
                          }}
                        />
                    </div>
                    <FieldFeedbacks for="number_expiry_day">
                      <FieldFeedback when="*" />
                    </FieldFeedbacks>
                        <FieldFeedbacks for="passport_or_id_number_expiry_year">
                          <FieldFeedback when="*" />
                        </FieldFeedbacks>
                  </div>

                  {/* Email and Phone */}
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                    gap: "24px",
                    marginBottom: "24px"
                  }}>
                    <div>
                      <label style={formLabelStyle(false)}>
                        {translation.t("Email")}
                      </label>
                    <input
                      type="email"
                        style={inputStyle}
                        placeholder={translation.t("Email")}
                      required
                      name="email"
                      onChange={(event) => {
                        setMainPassengerForm({
                          ...mainPassengerForm,
                          email: event.target.value,
                        });
                        formRef.validateFields(event.target);
                      }}
                    />
                    <FieldFeedbacks for="email">
                      <FieldFeedback when="*" />
                    </FieldFeedbacks>
                  </div>
                    <div>
                      <label style={formLabelStyle(false)}>
                        {translation.t("phone")}
                      </label>
                      <div style={{ display: 'flex', gap: '10px', position: 'relative' }}>
                        {/* Phone Code Dropdown */}
                        <div style={{ width: '130px', position: 'relative' }} ref={phoneCountryDropdownRef}>
                          <div 
                            onClick={() => setIsPhoneCountryOpen(!isPhoneCountryOpen)}
                            style={{
                              ...inputStyle,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              padding: '8px 12px',
                              cursor: 'pointer',
                              height: '54px'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <img 
                                src={`https://flagcdn.com/w20/${selectedPhoneCountry.toLowerCase()}.png`}
                                alt="flag"
                                style={{ width: 20, height: 15 }}
                              />
                              <span>{extendedCountryTelData[selectedPhoneCountry]?.dial_code || '+383'}</span>
                            </div>
                            <svg 
                              width="12" 
                              height="12" 
                              viewBox="0 0 16 16"
                              style={{
                                transform: isPhoneCountryOpen ? 'rotate(180deg)' : 'rotate(0)',
                                transition: 'transform 0.2s ease'
                              }}
                            >
                              <path 
                                fill="none" 
                                stroke="currentColor" 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth="2" 
                                d="M2 5l6 6 6-6"
                              />
                            </svg>
                          </div>
                          
                          {isPhoneCountryOpen && (
                            <div 
                              style={{
                                position: 'absolute',
                                top: '100%',
                                left: '0',
                                backgroundColor: '#fff',
                                borderRadius: '12px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                zIndex: 9999999999,
                                width: '280px',
                                maxWidth: '90vw',
                                maxHeight: '500px',
                                overflow: 'hidden',
                                border: '1px solid #E5E9F2',
                                marginTop: '4px'
                              }}
                            >
                              <div style={{ padding: '16px', borderBottom: '1px solid #eef1f5' }}>
                                <input
                                  type="text"
                                  value={phoneCountrySearchQuery}
                                  onChange={(e) => setPhoneCountrySearchQuery(e.target.value)}
                                  placeholder={translation.t("Search country or code...")}
                                  style={{
                                    ...inputStyle,
                                    height: '44px',
                                    boxShadow: 'none',
                                    border: '1px solid #eef1f5'
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </div>
                              <div style={{ maxHeight: '440px', overflowY: 'auto' }}>
                                {filteredPhoneCountries.map(([code, data]) => (
                                  <div
                                    key={code}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedPhoneCountry(code);
                                      setIsPhoneCountryOpen(false);
                                      setPhoneCountrySearchQuery('');
                                    }}
                                    style={{
                                      padding: '14px 18px',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      transition: 'background-color 0.2s',
                                      backgroundColor: code === selectedPhoneCountry ? '#003663' : 'transparent',
                                      color: code === selectedPhoneCountry ? '#fff' : '#1a1a1a',
                                      fontSize: '15px',
                                      fontWeight: '500',
                                      borderBottom: '1px solid #f0f0f0'
                                    }}
                                    onMouseEnter={(e) => {
                                      if (code !== selectedPhoneCountry) {
                                        e.currentTarget.style.backgroundColor = '#F0F7FF';
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (code !== selectedPhoneCountry) {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                      }
                                    }}
                                  >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <img 
                                        src={`https://flagcdn.com/w20/${code.toLowerCase()}.png`}
                                        alt={data.name}
                                        style={{ width: 20, height: 15 }}
                                      />
                                      <span>{data.name}</span>
                                    </div>
                                    <span style={{ color: '#666' }}>{data.dial_code}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Phone Number Input */}
                        <div style={{ flex: 1, position: 'relative' }}>
                          <input
                            type="tel"
                            name="phone"
                            required
                            style={inputStyle}
                            placeholder={translation.t("Phone number")}
                            onChange={(event) => {
                              const value = event.target.value.replace(/[^\d\s\-\+\(\)]/g, '');
                          setMainPassengerForm({
                            ...mainPassengerForm,
                                phone: value,
                          });
                          formRef.validateFields(event.target);
                        }}
                      />
                      <FieldFeedbacks for="phone">
                        <FieldFeedback
                          when={(value) => !isPhoneNumber(value)}
                        >
                          Phone number is invalid
                        </FieldFeedback>
                      </FieldFeedbacks>
                        </div>
                      </div>
                    </div>
                  </div>

                  <BaggageSection
                    id={1}
                    key="baggage_section"
                    flight={flight}
                    handBagDimensions={handBagDimensions}
                    holdBagDimensions={holdBagDimensions}
                    holdBagsToPay={holdBagsToPay}
                    disableAddBaggage={disableAddBaggage}
                    setDisableAddBaggage={setDisableAddBaggage}
                    total={bookingFlightDetails?.total}
                    setPrice={setPrice}
                    addedBaggage={addedBaggage}
                    setAddedBaggage={(newBaggage, id, action) =>
                      setAddedBaggageHandler(newBaggage, id, action)
                    }
                    hideBagsToPayOption={noCheckedBaggage}
                    currency={CURRENCY_SIGN[currency?.curr]}
                    currentBnum={flight?.bnum}
                    baggageInfo={baggageInfo}
                    setNoCheckedBaggage={setNoCheckedBaggage}
                  />

                  {/* No Checked Baggage Button */}
                  <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
                    <Box
                      onClick={() => {
                        const toggled = !noCheckedBaggage;
                        setNoCheckedBaggage(toggled);

                        if (toggled) {
                          updateAncillary([]);
                          setAddedBaggage([]);
                          setTotalBaggagePrice(0);
                        }
                        removeWhenNoCheckedBaggage(1, addedBaggage);
                      }}
                      sx={{
                        position: 'relative',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: 120,
                        px: 3,
                        py: 1.5,
                        borderRadius: '999px',
                        fontWeight: 600,
                        fontSize: '0.875rem',
                        bgcolor: noCheckedBaggage ? '#003663' : '#FBD215',
                        color: noCheckedBaggage ? '#FBD215' : '#003663',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease-in-out',
                        boxShadow: 2,
                        '&:hover': {
                          bgcolor: noCheckedBaggage ? '#002a4f' : '#e8c30d',
                          transform: 'scale(1.1)',
                          boxShadow: 4,
                        },
                      }}
                    >
                      <Typography variant="body2" fontWeight={600} component="span">
                        No Checked Baggage(s)
                      </Typography>

                      {/* Selected Tick */}
                      {noCheckedBaggage && (
                        <Box sx={{
                          position: 'absolute',
                          top: -2,
                          right: -2,
                          bgcolor: 'primary.main',
                          color: 'white',
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '0.875rem',
                          fontWeight: 'bold'
                        }}>
                          ✓
                        </Box>
                      )}
                    </Box>
                  </Box>

                  <ManagePassengers
                    key="manage_passengers"
                    formRef={formRef}
                    flight={flight}
                    adults={adult}
                    children={children}
                    infants={babies}
                    handBagDimensions={handBagDimensions}
                    holdBagDimensions={holdBagDimensions}
                    holdBagsToPay={holdBagsToPay}
                    baggageInfo={baggageInfo}
                    countries={countries}
                    setAddedBaggage={(newBaggage, id, action) =>
                      setAddedBaggageHandler(newBaggage, id, action)
                    }
                    addedBaggage={addedBaggage}
                    removeWhenNoCheckedBaggage={(id, bags) =>
                      removeWhenNoCheckedBaggage(id, bags)
                    }
                    currency={currency?.curr}
                    setUpdatedFlight={(updatedFlight) => {
                      setCurrentPrice(updatedFlight?.totalPrice);
                      setCurrentTotalPassengers(
                        updatedFlight?.totalPassengers
                      );
                      setBookingDetails(updatedFlight);
                    }}
                    setPassengers={(list) => setPassengersList(list)}
                  />
                </FormWithConstraints>
                </div>
              </div>
          </div>
          {/* Right Column - Price Summary */}
          <div style={{
            flex: isMobile ? "1" : "1",
            width: isMobile ? "100%" : "auto",
            position: isMobile ? "static" : "sticky",
            top: "20px",
            alignSelf: "flex-start"
          }}>
            <div style={{
              ...cardStyle,
              margin: "0",
              maxWidth: "400px",
              marginLeft: isMobile ? "auto" : "0",
              marginRight: "auto"
            }}>
              <div style={blendOverlayStyle} />
              <div style={{ position: "relative", zIndex: 2 }}>
                {/* Flight Image */}
                <div style={{
                  width: "calc(100% + 48px)", // stretch over card horizontal padding
                  minHeight: "180px",
                  background: `linear-gradient(rgba(0, 54, 99, 0.43), rgba(0, 54, 99, 0.43)),
                    url(${currentImage || "https://images.kiwi.com/photos/472x440/photos.jpg"}) no-repeat center center / cover`,
                  borderRadius: "12px 12px 0 0",
                  padding: "16px 24px",
                  margin: "-24px -24px 24px", // pull to edges, keep bottom margin
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start"
                }}>
                  <h6 style={{
                    color: "white",
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    margin: 0,
                    textShadow: "0 2px 4px rgba(0,0,0,0.7)"
                  }}>
                    {obCityFrom} - {obCityTo}
                  </h6>
                </div>

                {/* Price Breakdown */}
                <div style={{ marginBottom: "24px" }}>
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                    padding: "12px 0",
                    borderBottom: "1px solid #E5E9F2"
                  }}>
                    <span style={{
                      color: primaryColor,
                      fontSize: "1rem",
                      fontWeight: "500"
                    }}>
                      {currentTotalPassengers}× {translation.t("passenger")}
                      {currentTotalPassengers > 1 && "'s"}
                    </span>
                    <span style={{
                      color: primaryColor,
                      fontSize: "1.1rem",
                      fontWeight: "600"
                    }}>
                      {passengersPriceFirst}
                      <sup>{passengerPriceSecond || ""}</sup>
                      {CURRENCY_SIGN[currency?.curr]}
                    </span>
                  </div>

                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                    padding: "12px 0",
                    borderBottom: "1px solid #E5E9F2"
                  }}>
                    <span style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color: primaryColor,
                      fontSize: "1rem",
                      fontWeight: "500"
                    }}>
                      <img src={BagGreen} alt="backpack" style={{ width: 32, height: 32 }} />
                      {translation?.i18n?.language === "al" ? "Qantë falas" : "Free backpack"}
                    </span>
                    <span style={{
                      color: "#003663",
                      fontSize: "1.1rem",
                      fontWeight: "600"
                    }}>
                      {translation.t("free")}
                    </span>
                  </div>

                  {finalBagg?.[0]?.ancillary.baggagePrice > 0 && (
                    <AddedBaggageSection
                      baggageList={finalBagg}
                      key="added_baggage_section"
                    />
                  )}

                  {/* Total Price */}
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "24px",
                    padding: "16px 0",
                    borderTop: "2px solid #003663"
                  }}>
                    <span style={{
                      color: primaryColor,
                      fontSize: "1.2rem",
                      fontWeight: "700"
                    }}>
                      {translation.t("total_price")}
                    </span>
                    <span style={{
                      color: primaryColor,
                      fontSize: "1.6rem",
                      fontWeight: "700"
                    }}>
                      {priceLoading ? (
                        <>
                          <CircularProgress size={16} style={{ marginRight: "8px" }} />
                          <span style={{ fontSize: "1rem", fontWeight: "500", color: "#003663" }}>Updating...</span>
                        </>
                      ) : (
                        <>
                          {firstPrice}
                          <sup>{secondPrice || ""}</sup>
                          {CURRENCY_SIGN[currency?.curr]}
                        </>
                      )}
                    </span>
                  </div>

                  {/* Price error state removed */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Promo Code Section */}
        <div style={{
          ...cardStyle,
          marginBottom: "40px",
          maxWidth: isMobile ? '100%' : 'calc(100% - 440px)', /* align with main form width (gap 40 + right card 400) */
          marginLeft: 0
        }}>
          <div style={blendOverlayStyle} />
          <div style={{ position: "relative", zIndex: 2 }}>
            <div style={{ marginBottom: "24px" }}>
              <div style={{ marginBottom: "16px", paddingLeft: "4px" }}>
                <Form.Check
                  type="checkbox"
                  id="promo_code"
                  checked={promoCode}
                  onChange={(event) => {
                    setPromoCode(event.target.checked);
                  }}
                  style={{
                    color: primaryColor,
                    fontSize: "1rem",
                    fontWeight: "500"
                  }}
                  label={
                    <span style={{ 
                      color: primaryColor, 
                      fontSize: "1rem", 
                      fontWeight: "500",
                      marginLeft: "8px"
                    }}>
                  {translation.t("add_promo_code")}
                    </span>
                  }
                />
              </div>

              {!!promoCode && (
                <div style={{
                  display: "flex",
                  gap: "16px",
                  alignItems: "flex-end",
                  flexDirection: isMobile ? "column" : "row"
                }}>
                  <div style={{ flex: 1, minWidth: "200px" }}>
                    <label style={{ ...formLabelStyle(false), marginLeft: '8px' }}>
                      {translation.t("Promo Code")}
                    </label>
                    <input
                      type="text"
                      style={inputStyle}
                      placeholder={translation.t("Enter promo code")}
                      required
                      name="promo_code"
                      onChange={(event) => {
                        setPromoCodeValue(event.target.value);
                      }}
                    />
                  </div>
                    <Button
                      variant="contained"
                      sx={{
                      borderRadius: "30px",
                      backgroundColor: "#fbd215",
                      color: primaryColor,
                      border: "none",
                      padding: "12px 24px",
                      fontWeight: "600",
                      height: "54px",
                      minWidth: "120px",
                      transition: "all 0.2s ease-in-out",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      "&:hover": { 
                        backgroundColor: "#fbd215",
                        transform: "scale(1.05)",
                        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)"
                      }
                      }}
                      disabled={!promoCodeValue || voucherInfo?.loading}
                      onClick={async () => {
                        setVoucherInfo((prev) => ({
                          ...prev,
                          loading: true,
                        }));
                        try {
                          const applyVoucherResponse = await POST(
                            `${MAIN_LAMBDA}/apply-voucher`,
                            {
                              body: JSON.stringify({
                                voucher: promoCodeValue,
                              }),
                            headers: {
                              "Content-Type": "application/json",
                            },
                            }
                          );

                          if (applyVoucherResponse.statusCode === 400) {
                            setVoucherInfo({
                              message: applyVoucherResponse.errorMessage,
                              code: 400,
                              loading: false,
                            });
                          }

                          if (
                            applyVoucherResponse.statusCode === 200 &&
                            applyVoucherResponse.amount
                          ) {
                            setVoucherInfo({
                              message: "Voucher applied successfully!",
                              code: 200,
                              loading: false,
                            });
                            setCurrentPrice(
                              currentPrice -
                              Number(applyVoucherResponse.amount)
                            );
                          }
                        } catch (err) {
                          setVoucherInfo({
                            message: "Something went wrong!",
                            code: 500,
                            loading: false,
                          });
                        }
                      }}
                    >
                    {voucherInfo?.loading ? (
                      <CircularProgress size={20} style={{ color: primaryColor }} />
                    ) : (
                      translation.t("apply")
                    )}
                    </Button>
                  </div>
              )}

              {voucherInfo?.message && (
                <div style={{
                  marginTop: "16px",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  backgroundColor: voucherInfo.code === 200 ? "#d4edda" : "#f8d7da",
                  color: voucherInfo.code === 200 ? "#155724" : "#721c24",
                  border: `1px solid ${voucherInfo.code === 200 ? "#c3e6cb" : "#f5c6cb"}`,
                  fontSize: "14px",
                  fontWeight: "500"
                }}>
                  {voucherInfo.message}
            </div>
              )}
                      </div>
              </div>
            </div>

        {/* Consent Checkbox */}
        <div className="mb-5" style={{ backgroundColor: "transparent", padding: 0, width: isMobile ? '100%' : 'calc(100% - 440px)' }}>
          <div style={{ 
            backgroundColor: "#fff",
            borderRadius: "0 0 12px 12px",
            padding: "24px", 
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderTop: "none",
            position: "relative",
            overflow: "hidden",
            width: "100%"
          }}>
            <div style={blendOverlayStyle} />
            <div style={{ position: "relative", zIndex: 2, paddingLeft: "4px" }}>
              <Form.Check
              type="checkbox"
              id="consent"
                checked={consent}
              onChange={(event) => {
                setConsent(event.target.checked);
              }}
                required
                style={{ 
                  color: primaryColor,
                  fontSize: "1rem",
                  fontWeight: "500"
                }}
                label={
                  <span style={{ 
                    color: primaryColor, 
                    fontSize: "1rem", 
                    fontWeight: "500", 
                    lineHeight: "1.5",
                    marginLeft: "8px"
                  }}>
              {translation.t("accept")}{" "}
                    <a 
                      href="/terms-conditions" 
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#0156B3', textDecoration: 'none' }}
                    >
                {translation.t("terms_and_conditions")}
              </a>{" "}
                    {translation.t(" and ")}{" "}
                    <a 
                      href="/privacy" 
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#0156B3', textDecoration: 'none' }}
                    >
                {translation.t("privacy_policy")}
              </a>
                  </span>
                }
              />
          </div>
        </div>
        </div>

        {/* Submit Button */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "40px" }}>
          <button
            type="submit"
            id="buttonPayment"
            disabled={!consent || disableBookingButton}
            style={{
              backgroundColor: "#fbd215",
              color: primaryColor,
              border: "none",
              borderRadius: "30px",
              padding: "16px 32px",
              fontWeight: "800",
              fontSize: "1.1rem",
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
              height: "56px",
              minWidth: "240px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              cursor: !consent || disableBookingButton ? "not-allowed" : "pointer",
              opacity: !consent || disableBookingButton ? 0.7 : 1
            }}
            onClick={async () => submitBooking()}
            onMouseEnter={(e) => {
              if (!(!consent || disableBookingButton)) {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 12px 20px rgba(0, 0, 0, 0.2)";
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.15)";
            }}
          >
            {!!bookingLoading && (
              <CircularProgress
                size={20}
                style={{ color: primaryColor }}
              />
            )}
            <span>{translation.t("book_now")}</span>
            {!priceLoading && (
              <span style={{ display: "flex", alignItems: "flex-start", fontWeight: 800 }}>
                <span style={{ fontSize: "1.15rem", marginTop: "1px" }}>
              {firstPrice}
                </span>
                <span style={{ fontSize: "0.9rem", lineHeight: "1.6", marginLeft: "1px", verticalAlign: "super" }}>
                  {secondPrice && <sup>{secondPrice}</sup>}
                </span>
                &nbsp;
                <span style={{ fontSize: "1.3rem" }}>{CURRENCY_SIGN[currency?.curr]}</span>
            </span>
            )}
          </button>
        </div>

          {showRedirectMessage && (
          <Alert severity={messageSeverity} style={{ marginBottom: "20px" }}>
            {redirectMessage}
          </Alert>
          )}
        </div>

      {/* Dialog */}
    <div>
      <Dialog
        onClose={() => { }}
        open={freshPriceDialog}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "5px"
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <span style={{
            color: "#003663",
            fontWeight: "bold"
          }} className="d-inline-block price-text w-100">{translation && translation.t("hurry_up")}</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            setFreshPriceDialog(false);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
            <h6 style={{
              color: "#003663",
              marginTop: "16px"
          }}>{translation && translation.t("remember_limited_time")}</h6>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setFreshPriceDialog(false);
            }}
            style={{
              borderRadius: "11px",
              color: "#003663",
                background: "#fbd215",
              marginRight: "10px",
              marginBottom: "10px",
              fontWeight: "bolder"
            }}
          >
            {translation && translation.t("got_it")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  </section>
);
};
